export enum TableColumnOptionKey {
    DisplayBooleanAsIcon = 'DisplayBooleanAsIcon',
    BooleanDisplayTrueValue = 'BooleanDisplayTrueValue',
    BooleanDisplayFalseValue = 'BooleanDisplayFalseValue',
}
